'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate from "./app.api.-General-Practice-App-Update.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo(buildTime) {
  this.Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo__f_buildTime = null;
  this.Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo__f_buildTime = buildTime;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo as $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo };
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype = new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate.$h_Lapp_api_GeneralPracticeAppUpdate();
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo as $h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo };
$h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1147971304, true);
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo)) {
    var x = this.Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo__f_buildTime;
    var x$2 = x$0.Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo__f_buildTime;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.productPrefix__T = (function() {
  return "AppUpdateInfo";
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.productElement__I__O = (function(n) {
  matchResult34: {
    var $x_1;
    if ((n === 0)) {
      var $x_1 = this.Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo__f_buildTime;
      break matchResult34;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime($x_1);
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "buildTime";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo)));
}
export { $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo as $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo };
var $d_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo, "app.api.GeneralPracticeAppUpdate$AppUpdateInfo", ({
  Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo: 1,
  Lapp_api_GeneralPracticeAppUpdate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  Lapp_api_GeneralPracticeAppUpdate$InitialState: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo as $d_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-App-Update-Info.js.map
